require('../css/styles.scss');
require('../images/owl.png');

import {app} from './app';

document.addEventListener('DOMContentLoaded', app.start);



// WEBPACK FOOTER //
// ./js/index.js